


















import {Component, Prop, Mixins} from 'vue-property-decorator'
import PolicyChapterTree from './PolicyChapterTree.vue'
import {IPolicyNode, PolicyType} from './model'
import renderWithPlatformDataMixin from '@/mixins/renderWithPlatformDataMixin'

@Component({
  components: {
    PolicyChapterTree
  }
})
export default class PolicyContent extends Mixins(renderWithPlatformDataMixin) {

  @Prop() readonly type!: PolicyType
  @Prop() readonly description?: string

  get desc(): string | undefined {
    let desc = this.description;
    return desc ? this.renderWithData(desc) : desc;
  }

  get content(): any[] {
    let content = (this.$i18n.messages[this.$i18n.locale] as any).policy;
    return content ? (content[this.type].content || []) : [];
  }

  get nodes(): IPolicyNode[] {
    return this.toNode(this.content);
  }

  private toNode(content: any[]): IPolicyNode[] {
    return content.map((node: any) => {
      return (typeof node === 'string') ? {
        label: this.renderWithData(node)
      } : {
        label: this.renderWithData(node[0]),
        nodes: this.toNode(node.slice(1))
      }
    })
  }

}
